import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { FeatureFlagName } from '../models/data/featureFlag';
import { ApiService } from './api.services';

/**
 * Gates the company-shell Single Property route (ITE-12009).
 * When enableUpdatedSysAdmin is OFF, deep links fall back to /property-details/:id.
 */
@Injectable({
	providedIn: 'root',
})
export class EnableUpdatedSysAdminGuard {
	constructor(
		private readonly apiService: ApiService,
		private readonly router: Router
	) {}

	async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
		const propertyId = route.paramMap.get('propertyId') ?? '';
		let flagOn = false;

		try {
			const flag = await this.apiService.getFeatureFlagByName(
				FeatureFlagName.enableUpdatedSysAdmin
			);
			flagOn = flag?.value === true;
		} catch {
			flagOn = false;
		}

		if (flagOn) {
			return true;
		}

		return this.router.createUrlTree(['/property-details', propertyId]);
	}
}
